<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="language_name" [ttModel]="edit.language_name" ttReadonly></tt-input>
        <tt-input ttLabel="prodlang_name" [(ttModel)]="edit.prodlang_name"></tt-input>
        <tt-input ttLabel="prodlang_name_short" [(ttModel)]="edit.prodlang_name_short"></tt-input>
        <tt-textarea ttLabel="salesinfo" [(ttModel)]="edit.salesinfo"></tt-textarea>
        <tt-textarea ttLabel="salesinfo2" [(ttModel)]="edit.salesinfo2"></tt-textarea>
        <tt-textarea ttLabel="salesinfo3" [(ttModel)]="edit.salesinfo3"></tt-textarea>
        <tt-textarea ttLabel="salesinfo4" [(ttModel)]="edit.salesinfo4"></tt-textarea>
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
